export const CATERING_BASE_PATH = '/catering-store-v2';
